module.exports = ".access-container {\r\n  text-align: center;\r\n  margin-top: 6rem;\r\n  font-family: 'Segoe UI', sans-serif;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/access-denied/access-denied.component.css
// module id = 969
// module chunks = 1